import TitleBlock from '@anm/components/TitleBlock';
import SecureCard, { SecureCardProps } from '@anm/components/credit-card/SecureCard';
import PaymentDetailsCard, {
  PaymentDetailsCardProps
} from '@anm/components/subscription/payment-details/PaymentDetailsCard';
import { FC } from 'react';

import { PaymentDetailsTitleWrapper, PaymentDetailsWrapper, SecureCardWrapper } from './Wrapper';

export type PaymentDetailsBlockProps = PaymentDetailsCardProps & SecureCardProps;

const PaymentDetailsBlock: FC<PaymentDetailsBlockProps> = ({ sslId, ...detailsCardProps }) => (
  <PaymentDetailsWrapper>
    <PaymentDetailsTitleWrapper>
      <TitleBlock title="Payment details" size="medium" level={2} />
      <SecureCardWrapper>
        <SecureCard sslId={sslId} />
      </SecureCardWrapper>
    </PaymentDetailsTitleWrapper>
    <PaymentDetailsCard {...detailsCardProps} />
  </PaymentDetailsWrapper>
);

export default PaymentDetailsBlock;
